import { defineFcm } from '../shared/factory';

export const FCM_COFFEE_GEO_PROFILE_QUALITY = defineFcm('coffee_geo_profile_quality')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'petition page',
		description: 'Indicates that localization fields (e.g. country, city, ...) should be present in the sign form.',
	});
